import { render, staticRenderFns } from "./cottageList.vue?vue&type=template&id=1fb87277&scoped=true"
import script from "./cottageList.vue?vue&type=script&lang=js"
export * from "./cottageList.vue?vue&type=script&lang=js"
import style0 from "./cottageList.vue?vue&type=style&index=0&id=1fb87277&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb87277",
  null
  
)

export default component.exports